import React, { useContext } from "react";
import { FaFire, FaFireExtinguisher, FaBell, FaWater } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./fire.jpg";

const FireSafety: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/fire-safety');
    } else {
      navigate('/login', { state: { from: '/booking/fire-safety' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Life Safety</span>
          <h1 className="hero-title">Fire Prevention & Fighting</h1>
          <p className="hero-subtitle">
            Combustion requires Fuel, Heat, and Oxygen. Learn to break the triangle
            and use extinguishers effectively.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Fire Triangle</h2>
              <p className="article-text">
                Fire is a chemical reaction. To extinguish it, remove one element:
                <br /><strong>Cooling:</strong> Removes Heat (Water).
                <br /><strong>Smothering:</strong> Removes Oxygen (Foam/CO2).
                <br /><strong>Starving:</strong> Removes Fuel (Closing valves).
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Classes of Fire</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Class A:</strong> Solids (Wood, Paper) → Water/Foam.</li>
                  <li><strong>Class B:</strong> Liquids (Petrol, Oil) → Foam/Powder (Never Water!).</li>
                  <li><strong>Class C:</strong> Gases (Propane) → Dry Powder.</li>
                  <li><strong>Class D:</strong> Metals (Magnesium) → Specialist Powder.</li>
                  <li><strong>Electrical:</strong> Live equipment → CO2 (No residue).</li>
                </ul>
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Using an Extinguisher (P.A.S.S.)</h2>
              <p className="article-text">
                <ol style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>P</strong>ull the pin.</li>
                  <li><strong>A</strong>im at the base of the fire.</li>
                  <li><strong>S</strong>queeze the handle.</li>
                  <li><strong>S</strong>weep from side to side.</li>
                </ol>
                <em>Only fight small fires if safe to do so. Otherwise, evacuate.</em>
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Fire Systems</h4>
              <ul className="key-list">
                <li><FaBell className="check-icon" /> Detectors & Alarms</li>
                <li><FaFireExtinguisher className="check-icon" /> Portable Extinguishers</li>
                <li><FaWater className="check-icon" /> Sprinklers / Hydrants</li>
                <li><FaFire className="check-icon" /> Fire Doors (Keep Shut)</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Fight or Flight?</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Learn when to use an extinguisher and when to run.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default FireSafety;
